































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import invoicesMixin from '@/mixins/invoices-mixin'
import Invoice from '@/types/Invoice.interface'
import { InvoiceParams } from '@/types/PaginationParams.interface'
import Person from '@/types/Person.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import IList from '@/types/components/IList.interface'
import TriPanelButton from '@/components/TriPanelButton.vue'
export default Vue.extend({
    mixins: [invoicesMixin],
    components: { TriPanelButton },
    props: {
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    data() {
        return {
            //  Tells the client we are mounted
            mounted: false,
            personInvoicesPlaceholder: {
                img: 'noInvoices',
                content: 'No Invoices to Display'
            }
        }
    },
    beforeDestroy() {
        //  When we leave, make sure we reset the invoices
        this.$store.commit('personSelectedInvoicesSet', [])
        //  Reset our pagination params
        this.$store.commit('personSelectedInvoicesPaginationReset')
        //  Deselect multiselected items
        this.$refs.invoicesList.multiSelectReset()
    },
    async mounted() {
        //  Refresh the invoices list on load
        await this.$store.dispatch('personSelectedInvoicesPaginate', this.person.id)

        //  We are now mounted
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            lastPage: 'personSelectedInvoicesLastPage',
            paginating: 'personSelectedInvoicesPaginating',
            scrollPositionRight: 'scrollPositionRight'
        }),
        invoices(): Invoice[] {
            //  If we have searched, return the search results
            if (this.searched) return this.searchResults
            //  Else, just display our templates
            else return this.$store.getters.personSelectedInvoices
        },
        invoicesIList(): IList {
            return this.$store.getters.iList('invoicesList')
        },
        //  Returns an array of multi-selected invoiceIDs
        multiSelectedInvoiceIds(): number[] {
            //  If the invoicesIList does NOT exist, return empty array
            if (!this.invoicesIList) return []

            //  Assemble an array of multi-selected invoice ids
            const ids = this.invoicesIList.multiSelected.map(
                (invoice: Invoice) => invoice.id
            )

            //  Return the person ids
            return ids
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        personInvoicesParams: {
            get(): InvoiceParams {
                return this.$store.getters.personSelectedInvoicesParams
            },
            set(val: InvoiceParams): void {
                this.$store.commit('personSelectedInvoicesParamsSet', val)
            }
        }
    },
    methods: {
        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.personInvoicesParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage

            //  (our computed setter will apply this in the store)
            this.personInvoicesParams = params

            //  Deselect multiselected items
            this.$refs.invoicesList.multiSelectReset()

            //  Paginate the next page
            this.$store.dispatch('personSelectedInvoicesPaginate', this.person.id)
        }
    },
    watch: {
        person(val: Person): void {
            if (val) this.paginateCurrentList()
        },
        scrollPositionRight(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        }
    }
})
